import {VIEW_RECEIVED_MESSAGES} from '../constants/dashboard-const';

export const onNumberTap = (number)=>{
    return {
        type: VIEW_RECEIVED_MESSAGES,     
        number : number,
    };
}